import PlanoAcaoHandler from "@components/Handlers/PlanoAcaoHandler/Index";
import RelatorioHandler from "@components/Handlers/RelatorioHandler/Index";
import { FormularioOptionProcessoModal } from "@components/Modals/User/FormularioOptionProcessoModal/Index";
import ButtonComp from "@components/UI/Button/Index";
import RenderIfStatusAndRole from "@components/UI/RenderIfStatusAndRole/Index";
import { useSolicitacaoRespostaHandlers } from "@hooks/functions/Solicitacao/User/useSolicitacaoRespostaHandlers";
import { perfisUnidadeGerencia } from "@utils/auth/perfis";

function ButtonActions({
    methods,
    solicitacaoFields,
    relatorios,
    planosAcao,
    solicitacaoProcessoItems
}) {

    const {
        onSubmitRequest,
        onSubmitActionPlan
    } = useSolicitacaoRespostaHandlers({
        solicitacaoFields,
        solicitacaoProcessoItems
    });

    return (
        <form onSubmit={methods.handleSubmit(onSubmitRequest)} noValidate>
            <div className="row mt-4">
                <div className="col-12 col-md-12">
                    <div className="block h-auto">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="d-flex justify-content-center gap-2">

                                        {/* RESPONDER E VISUALIZAR FORMULÁRIOS DO PROCESSO */}
                                        <FormularioOptionProcessoModal
                                            idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                            idSolicitacao={solicitacaoFields?.id}
                                            idFormularioAssociado={solicitacaoFields?.formularioAssociadoProcesso?.id}
                                            formularioModeloInicial={solicitacaoFields?.formularioAssociadoProcesso}
                                            formularioRespostaInicial={solicitacaoFields?.formularioRespostaProcesso}
                                        />

                                        {/* ENVIO DA RESPOSTA DA SOLICITAÇÃO */}
                                        <RenderIfStatusAndRole
                                            idSolicitacao={solicitacaoFields?.id}
                                            allowedStatuses={[3]}
                                            allowedRoles={perfisUnidadeGerencia}
                                        >
                                            <ButtonComp
                                                title={"ENVIAR RESPOSTA"}
                                                type={"submit"}
                                                buttonColor={"#125578"}
                                                classnameIcon={"fa-solid fa-check"}
                                                hoverMessage={"Botão para enviar resposta da solicitação"}
                                            />
                                        </RenderIfStatusAndRole>

                                        {/* VISUALIZAR RELATÓRIOS */}
                                        <RelatorioHandler
                                            idSolicitacao={solicitacaoFields?.id}
                                            idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                            idUnidadeGerencia={solicitacaoFields?.unidadeGerencia?.id}
                                            flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                                            relatoriosExistentes={relatorios}
                                        />

                                        {/* ANEXAR PLANO DE AÇÃO */}
                                        <PlanoAcaoHandler
                                            idSolicitacao={solicitacaoFields?.id}
                                            idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                            idUnidadeGerencia={solicitacaoFields?.unidadeGerencia?.id}
                                            codigoProcesso={solicitacaoFields?.compliance?.codigoProcesso}
                                            flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                                            planosAcaoExistentes={planosAcao}
                                        />

                                        {/* ENVIAR PLANO DE AÇÃO */}
                                        <RenderIfStatusAndRole
                                            idSolicitacao={solicitacaoFields?.id}
                                            allowedStatuses={[5]}
                                            allowedRoles={perfisUnidadeGerencia}
                                            flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                                            onlyIfAuditoria={true}
                                        >
                                            <ButtonComp
                                                title={"ENVIAR PLANO DE AÇÃO"}
                                                buttonColor={"#2b97be"}
                                                type={"button"}
                                                onClick={onSubmitActionPlan}
                                                classnameIcon={"fa-regular fa-floppy-disk"}
                                                hoverMessage={"Botão para enviar o plano de ação"}
                                            />
                                        </RenderIfStatusAndRole>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default ButtonActions;